import {
  ExportActions,
  ExportActionTypes,
} from '@app/core/ngrx/actions/export.actions';

/**
 * ExportState
 */
export interface ExportState {
  exportBy: any;
}

/**
 * EXPORT_INITIAL_STATE
 * @type {{exportBy: string}}
 */
export const EXPORT_INITIAL_STATE: ExportState = {
  exportBy: null,
};

/**
 * exportReducer
 * @param {ExportState} state
 * @param {ExportActions} action
 * @returns {ExportState}
 */
export const exportReducer = (
  state: ExportState = EXPORT_INITIAL_STATE,
  action: ExportActions,
): ExportState => {
  switch (action.type) {
    case ExportActionTypes.LOAD_EXPORT_BY:
      return {
        ...state,
        exportBy: action.payload,
      };
    case ExportActionTypes.CLEAR_EXPORT_BY:
      return {
        ...state,
        exportBy: null,
      };
    default:
      return state;
  }
};
